"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeyIV = void 0;
const crypto_1 = require("crypto");
const HASHING_ALGORITHM = 'md5';
// PBE (Password-Based Encryption), MD5 and DES based encryption and decryption function
const keyDerivationFunction = ({ password, salt, iterations, }) => {
    const passwordBuffer = Buffer.from(password);
    // Use only the first 8 characters for the salt
    const saltBuffer = Buffer.from(salt.substr(0, 8));
    const keyBuffer = Buffer.concat([passwordBuffer, saltBuffer]);
    let hashedKeyBuffer = keyBuffer;
    for (let i = 0; i < iterations; i += 1) {
        hashedKeyBuffer = (0, crypto_1.createHash)(HASHING_ALGORITHM)
            .update(hashedKeyBuffer)
            .digest();
    }
    return hashedKeyBuffer;
};
const getKeyIV = ({ password, salt, iterations, }) => {
    const key = keyDerivationFunction({ password, salt, iterations });
    const keyBuffer = Buffer.from(key).slice(0, 8);
    const ivBuffer = Buffer.from(key).slice(8, 16);
    return { key: keyBuffer, iv: ivBuffer };
};
exports.getKeyIV = getKeyIV;
//# sourceMappingURL=keyDerivation.js.map